import useAppState from './useAppState'
import useAppInsights from './useAppInsights'
import { environment } from '../../config/environment'

const useTracking = () => {
    const appInsights = useAppInsights()
    const { currentUser, currentTenant } = useAppState()
    const { mode } = environment
    const shouldLog = mode !== 'local' && mode !== 'test'
    const trackError = (error) => {
        if (shouldLog) {
            appInsights.trackException({
                exception: error,
                properties: {
                    currentUserId: currentUser && currentUser.id,
                    currentTenantGuid: currentTenant && currentTenant.guid,
                },
            })
        } else {
            // eslint-disable-next-line no-console
            console.log(error)
        }
    }
    return {
        trackError,
    }
}
export default useTracking
